import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { save, load } from "redux-localstorage-simple"

const createStoreWithMiddleware = compose(applyMiddleware(thunk, save()))(createStore)
let store = createStoreWithMiddleware(reducers,load())
export { store }
